"use client";

import { useEffect, useRef, useState } from "react";

import {
  type CuratedHomeBrandRail,
  type CuratedHomeProductRail,
  fetchHomeCuratedRails,
} from "@/lib/shop-agent-client";
import { productFromListItem } from "@/lib/shopper-search-items";
import { SECTION_PADDING_Y } from "@/styles/responsive-spacing";

import { CuratedBrandRail } from "./CuratedBrandRail";
import { CuratedSearchRail } from "./CuratedSearchRail";

export function CuratedSearchSection() {
  const [productRails, setProductRails] = useState<CuratedHomeProductRail[]>([]);
  const [brandRails, setBrandRails] = useState<CuratedHomeBrandRail[]>([]);
  const fetchedRef = useRef(false);

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;

    let stale = false;
    const load = async () => {
      try {
        const response = await fetchHomeCuratedRails();
        if (stale) return;
        setProductRails(response.product_rails ?? []);
        setBrandRails(response.brand_rails ?? []);
      } catch (error) {
        console.error("Failed to load curated home rails:", error);
      }
    };
    void load();
    return () => {
      stale = true;
    };
  }, []);

  if (productRails.length === 0 && brandRails.length === 0) return null;

  return (
    <section
      className="flex w-full flex-col"
      style={{
        paddingTop: "clamp(24px, 5vw, 48px)",
        paddingBottom: SECTION_PADDING_Y.SMALL,
        gap: "clamp(24px, 4vw, 40px)",
      }}
    >
      {productRails.map((rail) => (
        <CuratedSearchRail
          key={rail.query.handle}
          query={rail.query}
          products={(rail.search.products ?? []).map(productFromListItem)}
        />
      ))}
      {brandRails.map((rail) => (
        <CuratedBrandRail
          key={rail.query.handle}
          query={rail.query}
          brands={rail.search.results ?? []}
        />
      ))}
    </section>
  );
}
